const code =
  '#include<iostream>\nusing namespace std;\nint main()\n{\n\t//Code\n\tcout<<"Hello World";\n\treturn 0;\n}';

export default code;
